import React from "react";
import styles from "./Assessment2ThankYou.module.css";
import quiz from "../../../json/Quiz.json";
import Assessment2Shell, { RailLens } from "../Assessment2Shell/Assessment2Shell";

const cfg = quiz.assessment2;

/* Final confirmation screen in the Assessment 2 shell. The next-step note lives
   in the left rail; the right column holds the responses summary (Q1–Q6 +
   fitting set — the Q7 readiness detail is intentionally left out). One
   "Back to Home" action in the footer. */
const Assessment2ThankYou = ({ thankYou, userInfo, summary, onHome }) => {
  const rail = (
    <>
      <span className={styles.railEyebrow}>{thankYou.eyebrow}</span>
      <h1 className={styles.railTitle}>
        {thankYou.heading}
        {userInfo.firstName ? `, ${userInfo.firstName}` : ""}
      </h1>
      <p className={styles.railText}>{thankYou.message}</p>
      <RailLens />
    </>
  );

  return (
    <Assessment2Shell
      stepIndex={cfg.totalSteps - 1}
      allComplete
      rail={rail}
      railFilled
      hideHeader
      hideFooter
      cornerAction={
        <button
          type="button"
          className={`${styles.tyHomeBtn} ${styles.tyHomeRail}`}
          onClick={onHome}
        >
       ← Back to home
        </button>
      }
    >
      <div className={styles.tyBody}>
      <div className={styles.tySummary}>
        <div className={styles.tySummaryHead}>
          <h3 className={styles.tySummaryTitle}>{thankYou.answersTitle}</h3>
          <button
            type="button"
            className={`${styles.tyHomeBtn} ${styles.tyHomeSummary}`}
            onClick={onHome}
          >
      ← Back to home
          </button>
        </div>
        <div className={styles.tyList}>
          {summary.map((row, i) => (
            <div key={i} className={styles.tyRow}>
              <span className={styles.tyKicker}>{row.kicker}</span>
              <span className={styles.tyAnswer}>{row.answer || "—"}</span>
            </div>
          ))}
        </div>
      </div>

      {thankYou.nextStep && (
        <div className={styles.tyNext}>
          <h4 className={styles.tyNextTitle}>{thankYou.nextStep.title}</h4>
          <p className={styles.tyNextText}>{thankYou.nextStep.message}</p>
        </div>
      )}
      </div>
    </Assessment2Shell>
  );
};

export default Assessment2ThankYou;
